import _get from "lodash/get";
import React from 'react';
import classnames from 'classnames';
import Button from '../button';
export default function Footer() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    prefixCls,
    locale,
    onCancelClick,
    onConfirmClick
  } = props;
  const wrapCls = classnames(`${prefixCls}-footer`);
  return /*#__PURE__*/React.createElement("div", {
    className: wrapCls
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "borderless",
    onClick: onCancelClick
  }, _get(locale, 'footer.cancel', '')), /*#__PURE__*/React.createElement(Button, {
    theme: "solid",
    onClick: onConfirmClick
  }, _get(locale, 'footer.confirm', '')));
}